import * as input from "./plain-inputs";
import { VariableInput as plainVariableInput } from "./inputs/variableInput";
import { YesNoBoolean as plainYesNoBoolean } from "./custom/yesNoBooleanList";
import { default as plainMeasurement } from "./custom/measurement";
import { ToggleSwitch as toggleswitch } from "./custom/toggle-switch";
import { MeasurementInputNew } from "./custom/measurement-input-new";
import { SelectActionList as ActionItemSelect } from "./select-acion-list/select-acition-list";

import { WithButton } from "./components/with-button";
import { WithLabel } from "./components/with-label";
import { WithCancel } from "./components/with-cancel";
import { WithOnClick } from "./shared/events";
import ListOf from "./shared/list-of";
import ListOfComplex from "./shared/list-of-complex";
import CellEditor from "./inputs/cell-editor";

export const Input = WithLabel(WithCancel(input.Input));
export const File = WithLabel(input.FileInput);
export const Select = WithLabel(input.Select);
export const Picklist = WithLabel(input.Picklist);
export const Checkbox = WithOnClick(input.Checkbox);
export const DatePicker = WithLabel(input.DateInput);
export const Textarea = WithLabel(input.Textarea);
export const NumberField = WithLabel(input.NumberInput);
export const Hidden = WithLabel(input.Hidden);
export const YesNoBoolean = WithLabel(plainYesNoBoolean);
export const Measurement = WithLabel(plainMeasurement);
export const InputList = WithLabel(ListOf(input.Input));
export const NumberList = WithLabel(ListOf(input.NumberInput));
export const MeasurementList = WithLabel(ListOfComplex(plainMeasurement));
export const VariableInput = WithLabel(plainVariableInput);
export const ToggleSwitch = WithLabel(toggleswitch);
export const ButtonInput = WithLabel(WithButton(input.Input));
export const ButtonNumberField = WithLabel(WithButton(input.NumberInput));
export const ButtonSelect = WithLabel(WithButton(input.Select));
// probably will replace 'Measurement'
export const MeasurementNew = WithLabel(MeasurementInputNew);
export const SelectActionList = WithLabel(ActionItemSelect);
export const InlineCellEditor = CellEditor;
